













































// Importing components
import LayoutApp from '@/layputs/LayoutApp.vue';
import BaseCardIcon from '@/ui/BaseCardIcon.vue';
// Importing functions
import {checkPermission} from '@/ts/helpers';

export default {
    name: 'PageDashboard',
    components: {
        LayoutApp,
        BaseCardIcon,
    },
    props: {},
    data() {
        return {};
    },
    methods: {
        permission(name) {
            return checkPermission(name);
        },
    },
};
